import React from 'react';
import PropTypes from 'prop-types';

// Lucide-derived (MIT) outline shape drawn in the Heroicons style — 24px
// viewBox, stroke=currentColor, strokeWidth=1.5, no fill. Heroicons doesn't
// ship a seedling glyph and the Figma source uses Font Awesome Pro Light.

SeedlingIcon.propTypes = {
  className: PropTypes.string
};

export default function SeedlingIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M7 20h10" />
      <path d="M10 20c5.5-2.5.8-6.4 3-10" />
      <path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z" />
      <path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z" />
    </svg>
  );
}
